/*!
 * el-table-infinite-scroll v2.0.0
 * (c) 2019-2022 yujinpan
 */

import ElTableInfiniteScroll from './el-table-infinite-scroll';
export { default } from './el-table-infinite-scroll';

ElTableInfiniteScroll.install = function (Vue) {
  Vue.directive('el-table-infinite-scroll', ElTableInfiniteScroll);
};
